import React, { useEffect, useState } from 'react';
import './style.css';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import http from '../../services/http-service'
import { useHistory } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
// import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import 'react-toastify/dist/ReactToastify.css';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { useCookies } from 'react-cookie';
import checkValidationFormAllControls from '../../constants/validation';
import wagefitlogo from "../../assets/wagefitlogo.png";
import { CommunicationService } from '../../services/communication-service';

function Copyright(props) {
  return (
    <Typography variant="body2" className='footer_blk' color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit">
        Wagefit
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const theme = createTheme();

export default function SignIn() {
  const [cookies, setCookie, removeCookie] = useCookies();
  const [checked,setCheck]=useState(false);
  useEffect(() => {
     localStorage.clear();
    if(cookies.email && cookies.password){
      const data = document.forms[0]
      data.elements.email.value=cookies.email;
      data.elements.password.value=cookies.password;
      data.elements.remember.checked=true;
      setCheck(true)
      // data.control=cookies.email
      console.log(cookies.email,data.elements);
    }
    // eslint-disable-next-line
  }, []);
  const history = useHistory();
  const [errorDisplay, seterrorDisplay] = useState('')
  const [open, setOpen] = useState(false);
  const checkClick=(event)=>{
    console.log(event.target.checked);
    if(event.target.checked){
      setCheck(true)
    }else{
      setCheck(false)
      removeCookie("email");
      removeCookie("password");
    }
  }
  const handleClose = () => {
    setOpen(false);
  };
  const handleToggle = () => {
    setOpen(!open);
  };

  const forgotPassword = () => {
    history.push("forgot-password")
  }
  // const handleChange=(event)=>{
  //   event.preventDefault();
  //   var objValidation ={};
  //   objValidation =checkValidationFormAllControls(event.target,false,[])
  //   if(objValidation.valid!==false){
            
  //     seterrorDisplay(objValidation);
  //     return ;
  //   }else{
  //     seterrorDisplay(objValidation);
  //   }
  // }
  const handleSubmit = (event) => {
    event.preventDefault();
    var objValidation = {};
    objValidation = checkValidationFormAllControls(document.forms[0].elements, false, [])
    if (objValidation.valid !== false) {
      seterrorDisplay(objValidation);
      return;
    } else {
      seterrorDisplay(objValidation);
    }
    sessionStorage.clear()
    localStorage.clear()
    const data = new FormData(event.currentTarget);
    let body = { email: data.get('email'), password: data.get('password') }
    handleToggle()
    http('admin/login/', 'POST', body)
      .then(res => res.data)
      .then(res => {

        if (res.status) {
          //this.setState({ apiResponse: res })
          localStorage.setItem("ACCESS_TOKEN", res.access_token)
          localStorage.setItem("REFRESH_TOKEN", res.refresh_token)
          localStorage.setItem("loginUser", JSON.stringify(res.data))
          if (res.data.is_onboarded) {
            
            history.replace("dashboard");
            toast.success(res.message,{
              toastId: "toastId1"
            })
            setLoginStatus()
          }
          else {
            history.push("change-password");
          }

          if (data.get('remember')) {
            setCookie('email', data.get('email'));
            setCookie('password', data.get('password'));
          } else {
            removeCookie("email");
            removeCookie("password");
          }


        }

        else {
          toast.error(res.message,{
            toastId: "toastId2"
          })
        }
        handleClose()
      })
      .catch(error => {
        // toast.error("Something went wrong!",{
        //   toastId: "toastId3"
        // })
        handleClose()
      });
  };

  const setLoginStatus = () =>{
    // send message to subscribers via observable subject
    CommunicationService.setLoggedInSatus(true);
  }

  return (
    <div>

      <ThemeProvider theme={theme}>

        <Container component="main" maxWidth="xs">
          <CssBaseline />
          <ToastContainer />

          <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={open}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          <Box className='topLoginBox'
            sx={{
              marginTop: 8,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}

          >
            <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }} className='LoginAvtar'>
            <img src={wagefitlogo} alt="logo" />
            </Avatar>
            <Typography component="h1" variant="h5">
              Sign in
            </Typography>
            <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoFocus
                type="email"

              />
              {errorDisplay.email ? <span style={{
                fontSize: '14px',
                color: '#dc0e0e'
              }}>{errorDisplay.email}</span> : ''}
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"

              />
              {errorDisplay.password ? <span style={{
                fontSize: '14px',
                color: '#dc0e0e'
              }}>{errorDisplay.password}</span> : ''}
              <FormControlLabel
                control={<Checkbox checked={checked} onClick={checkClick} name='remember' id='remember' color="primary" />}
                label="Remember me" className='rememberLabel'
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
              >
                Sign In
              </Button>
              <Grid container>
                <Grid item xs>
                  <Link onClick={forgotPassword} variant="body2" style={{cursor: 'pointer'}}>
                    Forgot password?
                  </Link>
                </Grid>
              </Grid>
            </Box>
          </Box>
          <Copyright sx={{ mt: 8, mb: 4 }} />
        </Container>
      </ThemeProvider>
    </div>

  );
}